import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Benefits } from './components/Benefits';
import { ProductDetails } from './components/ProductDetails';
import { Objections } from './components/Objections';
import { WhatsIncluded } from './components/WhatsIncluded';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { CTABlock } from './components/CTABlock';
import { SalesNotification } from './components/SalesNotification';
import { initMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-0">
      {/* Announcement Bar */}
      <div className="bg-[#E6007A] text-white text-center py-2 text-xs md:text-sm font-bold px-4" data-id="element-1">
        ENVÍO GRATIS A TODO EL PAÍS 🇦🇷 + 180 DIAS DE GARANTÍA
      </div>

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <Benefits data-id="element-5" />
        <CTABlock data-id="element-6" />
        <ProductDetails data-id="element-7" />
        <Objections data-id="element-8" />
        <WhatsIncluded data-id="element-9" />
        <Guarantee data-id="element-10" />
        <FAQ data-id="element-11" />
        <CTABlock data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
      <SalesNotification data-id="element-14" />
    </div>;
}